// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const FormWrapper = styled.div`
  padding: 1.5rem;
  background-color: var(--mb-color-background-primary);
  border-radius: var(--mantine-spacing-sm);
  border: 1px solid var(--mb-color-border-neutral);
  overflow-y: auto;
`;

export const FormTitle = styled.h4`
  margin-bottom: 1.5rem;
`;
